import { render, staticRenderFns } from "./Unit2ENG.vue?vue&type=template&id=2b332d68&scoped=true&"
import script from "./Unit2ENG.vue?vue&type=script&lang=js&"
export * from "./Unit2ENG.vue?vue&type=script&lang=js&"
import style0 from "./Unit2ENG.vue?vue&type=style&index=0&id=2b332d68&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b332d68",
  null
  
)

export default component.exports